/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M7 3V10M7 22L3 18M7 22L11 18M7 22V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 16V17.2C21 18.8802 21 19.7202 20.673 20.362C20.3854 20.9265 19.9265 21.3854 19.362 21.673C18.7202 22 17.8802 22 16.2 22H16M19 10V2L16.5 4.5M19 10H21M19 10H17M21 16V16C21 14.8954 20.1046 14 19 14H18C16.8954 14 16 14.8954 16 16V16C16 17.1046 16.8954 18 18 18H19C20.1046 18 21 17.1046 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="16"
				y="14"
				width="5"
				height="4"
				rx="2"
				fill="currentColor"
			/>
			<path
				d="M21 16V17.2C21 18.8802 21 19.7202 20.673 20.362C20.3854 20.9265 19.9265 21.3854 19.362 21.673C18.7202 22 17.8802 22 16.2 22H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 10V2L16.5 4.5M19 10H21M19 10H17M21 16V16C21 14.8954 20.1046 14 19 14H18C16.8954 14 16 14.8954 16 16V16C16 17.1046 16.8954 18 18 18H19C20.1046 18 21 17.1046 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M21 16V17.2C21 18.8802 21 19.7202 20.673 20.362C20.3854 20.9265 19.9265 21.3854 19.362 21.673C18.7202 22 17.8802 22 16.2 22H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 10V2L16.5 4.5M19 10H21M19 10H17M21 16V16C21 14.8954 20.1046 14 19 14H18C16.8954 14 16 14.8954 16 16V16C16 17.1046 16.8954 18 18 18H19C20.1046 18 21 17.1046 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 16V17.2C21 18.8802 21 19.7202 20.673 20.362C20.3854 20.9265 19.9265 21.3854 19.362 21.673C18.7202 22 17.8802 22 16.2 22H16M3 18L4.5 19.5M11 18L7 22V14M7 3V10M19 10V2L16.5 4.5M19 10H21M19 10H17M21 16V16C21 14.8954 20.1046 14 19 14H18C16.8954 14 16 14.8954 16 16V16C16 17.1046 16.8954 18 18 18H19C20.1046 18 21 17.1046 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 16V17.2C21 18.8802 21 19.7202 20.673 20.362C20.3854 20.9265 19.9265 21.3854 19.362 21.673C18.7202 22 17.8802 22 16.2 22H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 10V2L16.5 4.5M19 10H21M19 10H17M21 16V16C21 14.8954 20.1046 14 19 14H18C16.8954 14 16 14.8954 16 16V16C16 17.1046 16.8954 18 18 18H19C20.1046 18 21 17.1046 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M21 16V17.2C21 18.8802 21 19.7202 20.673 20.362C20.3854 20.9265 19.9265 21.3854 19.362 21.673C18.7202 22 17.8802 22 16.2 22H16M7 22L3 18M7 22L11 18M7 22V14M7 3V10M19 10V2L16.5 4.5M19 10H21M19 10H17M21 16V16C21 14.8954 20.1046 14 19 14H18C16.8954 14 16 14.8954 16 16V16C16 17.1046 16.8954 18 18 18H19C20.1046 18 21 17.1046 21 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
